import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { EventView } from "@shared/types";
import { StatusPill } from "../components/Status";

export function Events() {
  const [events, setEvents] = useState<EventView[]>([]);
  useEffect(() => {
    api<{ events: EventView[] }>("/api/events").then((r) => setEvents(r.events)).catch(() => setEvents([]));
  }, []);
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Event Observatory</p>
        <h1>Observed floods as tests of the model estate</h1>
        <p className="lede">Predicted → Observed → Difference → Explanation → Model learning. Residuals are not automatic corrections.</p>
        <div className="results">
          {events.map((e) => (
            <Link className="result" key={e.id} to={`/event/${e.slug}`}>
              <div className="record-meta">
                <span>{e.startedAt}</span>
                <StatusPill status={e.epistemic} />
              </div>
              <h3>{e.name}</h3>
              <p className="muted">{e.summary}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
